import { queryOptions } from '@tanstack/react-query';

import type { DashboardPageData } from './get-dashboard-page-data.ts';
import { getDashboardPageData } from './get-dashboard-page-data.ts';

export const DASHBOARD_PAGE_QUERY_KEY = ['dashboard-page'] as const;

export function getDashboardPageDataQueryOptions() {
	return queryOptions<DashboardPageData>({
		queryFn: () => getDashboardPageData(),
		queryKey: DASHBOARD_PAGE_QUERY_KEY,
	});
}
